/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['../../features/dashboard/dashboardSettings/DashboardSettingsAPI'], (DashboardSettingsAPI) => {
	/**
	 * @class DashboardSettingsService
	 * @implements {@link DashboardSettingsAPI}
	 * @hideconstructor
	 * @classdesc Glass service providing an implementation of {@link DashboardSettingsAPI}
	 */
	class DashboardSettingsService extends DashboardSettingsAPI {

		getAPI() {
			return this;
		}
	}
	return DashboardSettingsService;
});